module.exports = __webpack_public_path__ + "img/239-hawaii.c3d1c9bb.svg";